import { getTreeItemPadding } from './types';

interface TreeSkeletonsProps {
  depth: number;
  count?: number;
}

export function TreeSkeletons({ depth, count = 5 }: TreeSkeletonsProps) {
  return (
    <>
      {[...Array(count)].map((_, i) => (
        <div key={i} className="py-1" style={getTreeItemPadding(depth)}>
          <div className="flex items-center gap-1.5">
            <div className="h-4 w-4 bg-muted rounded animate-pulse" />
            <div
              className="h-3 bg-muted rounded flex-1 animate-pulse"
              style={{ width: `${50 + Math.random() * 30}%` }}
            />
          </div>
        </div>
      ))}
    </>
  );
}
